<template>
    <div class="wa-button-toggle">
        <div v-if="record">
            <button v-if="!isPlaying" @click="$emit('start-record')">
                <svg t="1672292803278" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="4309" width="200" height="200">
                    <path d="M515.2 64c-246.4 0-448 201.6-448 448s201.6 448 448 448 448-201.6 448-448-201.6-448-448-448z m0 576c-70.4 0-128-57.6-128-128s57.6-128 128-128 128 57.6 128 128-57.6 128-128 128z" fill="currentColor" p-id="4310"></path>
                </svg>
            </button>
            <button v-else @click="$emit('stop-record')">
                <svg class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="8052" width="200" height="200"><path d="M512 1024A512 512 0 1 1 512 0a512 512 0 0 1 0 1024zM320 320v384h384V320H320z" fill="currentColor" p-id="8053"></path></svg>
            </button>
        </div>
        <div v-else>
            <button v-if="!isPlaying" @click="$emit('start-play')">
                <svg class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="9041" width="200" height="200">
                    <path
                        d="M512 0c-282.752 0-512 229.184-512 512s229.248 512 512 512c282.816 0 512-229.184 512-512s-229.184-512-512-512l0 0zM734.976 545.792l-273.088 199.104c-5.568 4.032-11.904 6.016-18.176 6.016-5.696 0-11.392-1.728-16.512-4.992-10.88-7.04-17.6-20.352-17.6-34.816l0-398.208c0-14.464 6.784-27.776 17.6-34.816 10.816-6.976 24.064-6.656 34.624 1.088l273.088 199.104c9.92 7.232 16 20.032 16 33.728s-6.08 26.496-15.936 33.792l0 0z"
                        fill="currentColor"
                        p-id="9042"
                    ></path>
                </svg>
            </button>
            <button v-else @click="$emit('stop-play')">
                <svg t="1672292934584" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="5229" width="200" height="200">
                    <path d="M512 1024A512 512 0 1 1 512 0a512 512 0 0 1 0 1024zM320 320v384h128V320H320z m256 0v384h128V320H576z" fill="currentColor" p-id="5230"></path>
                </svg>
            </button>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        isPlaying: {
            type: Boolean,
            default: false,
        },
        record: {
            type: Boolean,
            default: false,
        },
    },
};
</script>

<style lang="scss">
@include b(button-toggle) {
    @apply h-10 w-10 text-[#f8ecf6];
    animation: ripple 1.2s linear infinite;
    border-radius: 50%;
    @keyframes ripple {
        0% {
            box-shadow: 0 0 0 0 rgb(248, 236, 246), 0 0 0 0 rgba(255, 84, 46, 0.3), 0 0 0 7px rgba(255, 84, 46, 0.3);
        }

        100% {
            box-shadow: 0 0 0 0 rgb(248, 236, 246), 0 0 0 7px rgba(255, 84, 46, 0.3), 0 0 0 17px transparent;
        }
    }
    button {
        color: inherit;
        background: transparent;
        height: 2.5rem;
        width: 2.5rem;
        padding: 0;
    }
    .icon {
        height: 100%;
        width: 100%;
        transform: scale(1.2);
    }
}
</style>
